import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IOrderDetail, IOrderSearchFields, orderService } from '../../orderService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { convertRes2Blob } from '@/utils/exportFile'

export const vehicleDetialModel = createModel(function () {
    //列表数据源
    const [vehicleList, setVehicleList] = useState<IOrderDetail[]>([])
    //查询条件
    const [vehicleSearchParam, setVehicleSearchParam] = useState<IOrderSearchFields>({})
    //查看详情form
    const [detailLookList, setDetailLookList] = useState<any>([])
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    const [print, setPrint] = useState<boolean>(false)
    const [printStatus, setPrintStatus] = useState<string>('outDetial')
    const [showLogs, setShowLogs] = useState<boolean>(false)
    const [SelectedId, setSelectedId] = useState('')
    const [vehicleFormVal, setVehicleFormVal] = useState<IOrderSearchFields>({})
    const [imgLookData, setImgLookData] = useState({ visible: false, repairMode: '', id: '' })
    const { setLoadingInfo } = useGlobalModel()
    const [imageClassifyList, setImageClassifyList] = useState<any>([])
    const [detialVisible, setDetialVisible] = useState<boolean>(false)

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    const {
        user: { userName },
    } = useGlobalModel(({ user }) => [user])
    //列表查询
    const getOne = async (page: ISearchPage = pgCfgRef.current, searchValue: IOrderSearchFields = vehicleSearchParam, id) => {
        const searchParams = {
            ...searchValue,
            customerName: userName,
            customerVehicleCode: id,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await orderService.one(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        // setPgCfg(transPgToPagination({total: records.length,size: 100,current: 1,}));
        setDetailLookList(records)
        setVehicleFormVal(records.length > 0 ? records[0] : {})
        if (selectedRowKeys.length > 0) {
            let newList = selectedRowKeys.map((item) => item.id)
            setSelectedRowKeys(records.filter((list) => newList.includes(list.id)))
        } else {
            setSelectedRowKeys([])
        }
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IOrderSearchFields) => {
        setVehicleSearchParam({ ...vehicleSearchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setVehicleSearchParam({})
        setSelectedRowKeys([])
        // getOne(initPgCfg, {});
    }
    const exportData = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '快速导出中' })
        let ids: any = ''
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            ids = selectedRowKeys.map((item) => item.orderCode as string).toString()
        }
        try {
            const searchParams = {
                ...vehicleSearchParam,
                pageSize: -1,
                pageNum: 1,
                id: ids ? ids : '',
                orderCode: ids ? ids : '',
                // orders: orders.current,
                customerVehicleCode: vehicleFormVal.customerVehicleCode,
            }

            let result = await orderService.export(searchParams)
            result && setLoadingInfo({ loadingVisible: false, txt: '' })
            convertRes2Blob(result)
            // setSelectedRowKeys([])
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }
    return {
        /***field***/
        initPgCfg,
        selectedRowKeys,
        pgCfg,
        SelectedId,
        detailLookList,
        vehicleSearchParam,
        vehicleList,
        print,
        showLogs,
        vehicleFormVal,
        imgLookData,
        imageClassifyList,
        detialVisible,
        printStatus,
        /***method***/
        setPrintStatus,
        setDetialVisible,
        setImageClassifyList,
        setImgLookData,
        setVehicleFormVal,
        setShowLogs,
        setPrint,
        setVehicleSearchParam,
        setVehicleList,
        setDetailLookList,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        getOne,
        setSelectedId,
        setPgCfg,
        exportData,
    }
})
